// Shared key and invalidation path for the Contacts first-paint snapshot.
export const contactsCacheKey = (email: string) => `contacts_cache_v2_${email}`;

export function invalidateContactsCache(email: string): void {
  try { localStorage.removeItem(contactsCacheKey(email)); } catch {}
}
